import { render } from "./homeslide1.vue?vue&type=template&id=caba44ca&scoped=true"
import script from "./homeslide1.vue?vue&type=script&lang=js"
export * from "./homeslide1.vue?vue&type=script&lang=js"

import "./homeslide1.vue?vue&type=style&index=0&id=caba44ca&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caba44ca"]])

export default __exports__